import {StockRecordFacade} from "../../../lib/stock/stock-record.service";
import {StockRecordSelectorModel} from "./stock-record-selector-dialog.component";
import {Injectable} from "@angular/core";
import {Currency, CurrencyService} from "../../../lib/currency.service";
import {StockItemService} from "../../../lib/stock/stock-item.service";
import {DownloadedFile} from "../../../lib/util/downloaded-files";
import {WeightFactory} from "../../../util/weight-utils";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Injectable()
export class StockRecordFacadeMapper {
  private currencies: Array<Currency.Currency> = [];

  constructor(private currencyService: CurrencyService,
              private sanitizer: DomSanitizer,
              private stockItemService: StockItemService) {
    currencyService.query({
    }).subscribe(result => {
      this.currencies = result.items.toArray();
    })
  }

  public map(facade: StockRecordFacade[]): StockRecordSelectorModel[] {
    const result: StockRecordSelectorModel[] = [];
    facade.forEach(r => {
      const cc = this.currencies.find(c => c.currencyCode === r.stock_item.unit_price?.currency_code);
    const model = new StockRecordSelectorModel();
    model.id = r.stock_record_id;
    model.name = r.stock_item.name;
    model.stockName = r.stock.name;
    model.externalId = r.stock_item.external_id;
    model.amount = r.amount;
    model.unit = r.stock_item.unit;
    model.unitPrice = r.stock_item.unit_price?.value;
    model.priceCurrency = cc?cc.localizedName : '';
    model.vatRate = r.stock_item.unit_price?.vat_rate;
    model.intakeNetPriceLatest = r.intake_net_price_latest;
    if (r.stock_item.picture && r.stock_item.picture.content_hash) {
      this.stockItemService.downloadPicture({
        id: r.stock_item.stock_item_id,
      }).subscribe((res: DownloadedFile) => {
          model.pictureSrc = URL.createObjectURL(res.getBlob());
        }
      );
    }
    model.productCode = r.stock_item.product_code;
    model.packageData = r.stock_item.package_data;
    model.hunVtszNumber = r.stock_item.hun_vtsz_number;
    model.description = !r.stock_item.description ? undefined : this.sanitizeHtml(this.decodeHTMLEntities(r.stock_item.description));
    model.rawRecord = r;
    model.weight = r.stock_item.weight_in_grams ? WeightFactory.createWeightFromGram(r.stock_item.weight_in_grams, 'kg').toString() : undefined;
    result.push(model);
    });
    return result;
  }

  private sanitizeHtml(unsafeHtml: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(unsafeHtml);
  }

  private decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

}
